<div class="relative">
  <button
    app-icon-button
    (click)="onClose()"
    app-tooltip
    tooltip="Cancelar"
    class="absolute! right-px top-px block rounded-md rounded-br-none rounded-tl-none border-0 bg-base-whisper-500 shadow"
  >
    <svg-icon
      class="flex h-8 w-8 text-base-whisper-900 group-hover:text-theme-contrast"
      src="assets/icons/icon-close.svg"
    ></svg-icon>
  </button>
  <form class="m-0 h-[25vh] w-full p-0">
    <textarea
      #inputTextArea
      [formControl]="textCtrl"
      class="h-full w-full rounded-lg p-4 pr-16 text-sm"
      (keydown.shift.enter)="onSave()"
    ></textarea>
    @for (error of textCtrl?.errors | keyvalue; track error) {
      <div class="flex flex-wrap bottom-0 px-2 text-sm font-medium text-red-500" translate>
        {{ label(error.key) | translate: error.value }}
      </div>
    }
    <span class="absolute! bottom-2 left-2 text-right text-sm"> {{ limit }} caracteres restantes </span>
  </form>
  <button
    app-icon-button
    (click)="onSave()"
    placement="top-right"
    app-tooltip
    tooltip="Salvar (shift + enter)"
    class="absolute! bottom-px right-px block rounded-md rounded-tl-none rounded-tr-none border-0 bg-green-500 shadow"
  >
    <svg-icon
      class="flex h-8 w-8 text-green-700 group-hover:text-theme-contrast"
      src="assets/icons/icon-check.svg"
    ></svg-icon>
  </button>
</div>
